export const FILE_SIZE = 5 * 1000000;

export const FILE_TYPE_REGEX = new RegExp(/(^image\/)*(png|img|jpe?g|gif)/);

export const MAX_FILE_ALLOW_UPLOAD = 10;
